import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  driverModels: [],
  isLoadingDriverModels: false,
  driverModelDetails: {},
  isLoadingDriverModelDetails: false,
  isLoading: false,
  error: null,
  driverModelDownload: [],
  isLoadingdriverModelDownload: false,
};

export const getDriverModels: any = createAsyncThunk(
  "content/getDriverModels",
  async ({ PageNumber, pageSize, searchText, SortBy, SortDirection }: any) => {
    const res = await axios.get(`/slpapp/DriverModel/getall`, {
      params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    });

    const data = await res.data;
    return data;
  },
);

export const getDriverModelsByCode: any = createAsyncThunk(
  "content/getDriverModelsByCode",
  async ({ driverModelCode }: any) => {
    const res = await axios.get(`/slpapp/DriverModel/DriverModelbycode`, {
      params: { driverModelCode },
    });

    const data = await res?.data?.data;
    return data;
  },
);

export const addDriverModel: any = createAsyncThunk(
  "content/addDriverModel",
  async ({ payload, file }: any) => {
    try {
      const formData = new FormData();
      formData.append("PictureFile", file);

      const res = await axios.post(`/slpapp/DriverModel`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: {
          DriverModelCode: payload.driverModelCode,
          AssetTypeId: payload.assetTypeId,
          Description: payload.description,
          RatedWatt: payload.ratedWatt,
          SupplierId: payload.supplierId,
          ExpectedLifeTime: payload.expectedLifeTime,
          Remark: payload.remark,
        },
      });

      const data = await res?.data;
      return data;
    } catch (error: any) {
      console.error("Error uploading-file/ form sending:", error);
      throw error;
    }
  },
);

export const editDriverModel: any = createAsyncThunk(
  "content/editAssetModel",
  async ({ payload, driverModelCode, file }: any) => {
    try {
      const formData = new FormData();
      formData.append("PictureFile", file);

      const res = await axios.put(`/slpapp/DriverModel`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: {
          DriverModelCode: driverModelCode,
          AssetTypeId: payload.assetTypeId,
          Description: payload.description,
          RatedWatt: payload.ratedWatt,
          SupplierId: payload.supplierId,
          ExpectedLifeTime: payload.expectedLifeTime,
          Remark: payload.remark,
        },
      });

      const data = await res?.data;
      return data;
    } catch (error: any) {
      console.error("Error uploading-file/ form sending:", error);
      throw error;
    }
  },
);

export const deleteDriverModel: any = createAsyncThunk(
  "content/deleteAssetModel",
  async ({ driverModelCode }: any) => {
    const res = await axios.delete(`/slpapp/DriverModel`, {
      params: { driverModelCode },
    });

    const data = await res.data.data;
    return data;
  },
);

export const downloadDriverModelFile: any = createAsyncThunk(
  "content/downloadDriverModelFile",
  async ({
    fileType = "downloadPdf",
    tcCode = null,
    siteCode = null,
    blockCode = null,
    searchText = "",
    sortBy = null,
    sortDirection = "ASC",
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      searchText,
      sortBy,
      sortDirection,
    };

    try {
      const response = await axios.post(
        `/slpapp/DriverModel/getDriverModel/${fileType}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        },
      );

      let filename = response.headers["content-disposition"]
        .split(";")
        .find((n: any) => n.includes("filename="))
        .replace("filename=", "")
        .trim();

      let fileBlob;
      if (fileType === "downloadPdf") {
        fileBlob = new Blob([response.data], { type: "application/pdf" });
      } else {
        fileBlob = new Blob([response.data], {
          type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      }

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = filename;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading fault report:", error);
      throw error;
    }
  },
);

export const driverModelSlice = createSlice({
  name: "driverModel",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getDriverModels.pending, (state) => {
      state.isLoadingDriverModels = true;
    });
    builder.addCase(getDriverModels.fulfilled, (state, action) => {
      state.isLoadingDriverModels = false;
      state.driverModels = action.payload;
    });
    builder.addCase(getDriverModels.rejected, (state, action) => {
      state.isLoadingDriverModels = false;
      state.error = action.error.message;
    });

    builder.addCase(getDriverModelsByCode.pending, (state) => {
      state.isLoadingDriverModelDetails = true;
    });
    builder.addCase(getDriverModelsByCode.fulfilled, (state, action) => {
      state.isLoadingDriverModelDetails = false;
      state.driverModelDetails = action.payload;
    });
    builder.addCase(getDriverModelsByCode.rejected, (state, action) => {
      state.isLoadingDriverModelDetails = false;
      state.error = action.error.message;
    });

    builder.addCase(addDriverModel.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addDriverModel.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addDriverModel.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(editDriverModel.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(editDriverModel.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(editDriverModel.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteDriverModel.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteDriverModel.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteDriverModel.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(downloadDriverModelFile.pending, (state) => {
      state.isLoadingdriverModelDownload = true;
    });
    builder.addCase(downloadDriverModelFile.fulfilled, (state, action) => {
      state.isLoadingdriverModelDownload = false;
      state.driverModelDownload = action.payload;
    });
    builder.addCase(downloadDriverModelFile.rejected, (state, action) => {
      state.isLoadingdriverModelDownload = false;
      state.error = action.error.message;
    });
  },
});

export default driverModelSlice.reducer;
